import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=1e839924&scoped=true&"
import script from "./checkDetail.vue?vue&type=script&lang=js&"
export * from "./checkDetail.vue?vue&type=script&lang=js&"
import style0 from "./checkDetail.vue?vue&type=style&index=0&id=1e839924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e839924",
  null
  
)

export default component.exports